import { useState } from 'react';
// import { FaPen } from 'react-icons/fa';
// import Button from 'react-bootstrap/Button';
import IntVerFixedScalesPending from './IntVerFixedScalesPending';
import IntVerFixedScalesFinalized from './IntVerFixedScalesFinalized';
import IntVerFixedScalesExported from './IntVerFixedScalesExported';
import IntVerFilePreview from './IntVerFilePreview';

const IntVerFixedScales = () => {

  const [activeSection, setActiveSection] = useState(1);
  const [scalePreviewInfo, setScalePreviewInfo] = useState([]);
  const [scalePreviewInfoSrc, setScalePreviewInfoSrc] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  return (
    <>
      {isPreviewModalOpen ? 
        <IntVerFilePreview 
          scalePreviewInfo={scalePreviewInfo}
          scalePreviewInfoSrc={scalePreviewInfoSrc}
          closeModal={() => { setIsPreviewModalOpen(false); setScalePreviewInfo(null); setScalePreviewInfoSrc(null) }}
        /> 
      : null}
      <div className="d-flex flex-column overflow-auto">
        <div className="d-flex my-3 justify-content-between">
          <div className="d-flex">
            {['En Proceso', 'Finalizados', 'Exportados'].map((item, itemIdx) => 
              <div 
                key={itemIdx} 
                className={"text-center p-2 " + (activeSection === itemIdx ? "bg-lb-white-selected" : "cursor-pointer bg-lb-white")}
                onClick={() => setActiveSection(itemIdx)}
              >
                {item}
              </div>
            )}
          </div>
          {/* <div>
            <Button className="d-flex p-2 rounded-2 bg-lb-white" title="Datos Balanzas" onClick={() => console.log('editbalanzas')}>
              <FaPen color="white" size={17} className="icon-style"/>
              <span className="fs-7 ms-1">Datos Balanzas</span>
            </Button>
          </div> */}
        </div>
        {activeSection === 0 ? 
          <IntVerFixedScalesPending 
            openPreviewModal={(scaleInfo, scaleInfoSrc) => { setScalePreviewInfo(scaleInfo); setScalePreviewInfoSrc(scaleInfoSrc); setIsPreviewModalOpen(true)}} 
          /> 
        : null}
        {activeSection === 1 ? 
          <IntVerFixedScalesFinalized 
            openPreviewModal={(scaleInfo, scaleInfoSrc) => { setScalePreviewInfo(scaleInfo); setScalePreviewInfoSrc(scaleInfoSrc); setIsPreviewModalOpen(true)}} 
          /> 
        : null}
        {activeSection === 2 ? 
          <IntVerFixedScalesExported 
            openPreviewModal={(scaleInfo, scaleInfoSrc) => { setScalePreviewInfo(scaleInfo); setScalePreviewInfoSrc(scaleInfoSrc); setIsPreviewModalOpen(true)}} 
          /> 
        : null}
      </div>
    </>
  )
}

export default IntVerFixedScales;